import { Capacitor } from '@capacitor/core';
import classnames from 'classnames';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { PageTitle } from './PageTitle.jsx';

import { useApplication } from '../AppContext';

function filterClick(e) {
	e?.preventDefault?.();
	e?.stopPropagation?.();
}

const ProductClassNames = {
	'com.jdsoftwarellc.ginrummy.removeads': 'buttonRemoveAds',
	'com.jdsoftwarellc.ginrummy.fullversion': 'buttonFullVersion',
};

const Store = () => {
	const { t } = useTranslation();
	const app = useApplication();
	const [products, setProducts] = React.useState([]);

	React.useEffect(() => {
		if (!app.iap) {
			return;
		}

		(async () => {
			const newProducts = await app.iap.getCatalog();
			const hideProductIds = ['fullversion'];
			const filteredProducts = newProducts.filter(p => 
				!hideProductIds.some(hideId => p.productId?.includes(hideId))
			);
			setProducts(filteredProducts);
		})();
	}, [app.iap, app.userdata?.removeAds]);

	const handleBuyClick = React.useCallback((e, item, owned) => {
		filterClick(e);
		console.info('clicked buy, buying', item);

		if (owned) {
			app.onBuy(item);
			console.info(`tried to buy ${item} but already owned`);
			return;
		}

		app.iap.buy(item);
	}, [app.iap]);

	const handleRejectClick = React.useCallback((e, item) => {
		filterClick(e);
		console.info(`tried to buy ${item} but already owned`);
	}, []);

	const handleRestoreButton = React.useCallback((e) => {
		filterClick(e);
		console.info('clicked restore');
		app.iap.restore();
	}, [app.iap]);

	//The restore link is really only useful on iOS
	//On android, it just forwards to getPurchases
	const restoreLink = React.useMemo(() => {
		if (Capacitor.getPlatform() !== 'ios') {
			return null;
		}

		return (
			<li className="restorePurchaseHolder">
				<a href="#" onClick={handleRestoreButton}>
					Restore purchases
				</a>
			</li>
		);
	}, [handleRestoreButton]);

	const productList = React.useMemo(() => {
		const list = [];

		for (const product of products) {
			if (!product.canPurchase) {
				continue;
			}
			list.push(
				<li key={product.productId}>
					<a
						className={classnames('button', ProductClassNames[product.productId], product.owned && 'owned')}
						href="#"
						onClick={(e) => handleBuyClick(e, product.productId, product.owned)}
					>
						{t(product.title)}
						<div className="description">
								{product.owned ? t('Owned') : product.price}
						</div>
					</a>
				</li>,
			);
		}

		return list;
	}, [handleBuyClick, products, t]);

	return (

		<div id="Achievements1" className="page noAnimate">
			<div className="wrapper">
				<PageTitle className="paddingTop50">
					<h1>{t('Store')}</h1>
				</PageTitle>

				<ul className="buttonList storeList" >
					{productList}
					{restoreLink}
				</ul>

			</div>
		</div>
	);
};

export default Store;
